/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, ReactNode, useEffect, useState } from 'react'
import { VocdoniSDKClient, EnvOptions } from '@vocdoni/sdk'
import { Web3Provider } from '@ethersproject/providers'
import type { MetaMaskInpageProvider } from '@metamask/providers'

declare global {
  interface Window {
    ethereum?: MetaMaskInpageProvider
  }
}

interface VocdoniContextType {
  client: VocdoniSDKClient | null
}

const VocdoniContext = createContext<VocdoniContextType | undefined>(undefined)

export function VocdoniProvider({ children }: { children: ReactNode }) {
  const [client, setClient] = useState<VocdoniSDKClient | null>(null)

  useEffect(() => {
    if (window.ethereum) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const provider = new Web3Provider(window.ethereum as any)
      const client = new VocdoniSDKClient({
        env: EnvOptions.STG,
        wallet: provider.getSigner()
      })
      setClient(client)
    }
  }, [])

  return (
    <VocdoniContext.Provider value={{ client }}>
      {children}
    </VocdoniContext.Provider>
  )
}

export function useVocdoni() {
  const context = useContext(VocdoniContext)
  if (context === undefined) {
    throw new Error('useVocdoni must be used within a VocdoniProvider')
  }
  return context
}
